<template>
    <div class="card mb-3">
        <div class="card-body">
            <form v-on:submit.prevent="submit">
                <div class="row" >
                    <div class="col-9" >
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>عنوان طرح</label>
                                    <input class="form-control" v-model="title">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>قیمت</label>
                                    <input class="form-control ltr-input" v-model="price" @keyup="numberFormat">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>وضعیت</label>
                                    <select class="form-control" v-model="status">
                                        <option value="1">فعال</option>
                                        <option value="0">غیرفعال</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <label> نوع کارت </label>
                                <div class="row mt-2">
                                    <div class="col-4">
                                        <label class="rdiobox"><input @change="changeCardType(0)" v-model="cardType"
                                                name="customer-type" value="0" checked type="radio"><span> گیفت کارت </span></label>
                                    </div>
                                    <div class="col-4">
                                        <label class="rdiobox"><input @change="changeCardType(1)" v-model="cardType"
                                                name="customer-type" value="1" type="radio"><span> بن کارت </span></label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <label>دسته بندی ها</label>
                                <Vselect v-model="categoriesId" :reduce="item => item.categoryId" label="title" multiple
                                    :options="categories">
                                    <div slot="no-options">مقداری یافت نشد</div>
                                </Vselect>
                            </div>
                            <div v-if="$store.state.role == 'admin'" class="col-md-4">
                                 <div class="form-group">
                                    <label>موجودی</label>
                                    <input type="number" class="form-control" v-model="inventory">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div  class="col-3">
                        <div class="row">
                            <div class="col-12" >
                                <img v-if="address"  class="mb-4" :src="`https://cardapi.sabinarya.com${address}`" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-3">
                        <button style="width: 100%;" class="btn btn-primary">ذخیره اطلاعات</button>
                    </div>
                </div>
                <div v-if="stocks.length>0 && $store.state.role == 'admin'"  class="row mt-5">
                    <div class="col-6">
                        <DataTable :columns="columns" :rows="stocks" :count="stocks.length" v-if="stocks.length"/>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Create',
    data() {
        return {
            showLoading: false,
            title: '',
            price: '',
            image: '',
            inventory: 0,
            status: 0,
            categories: [],
            categoriesId: [],
            cardType: 0,
            address:"",
            stocks:[],
            count: 0,
            columns: [
                {
                    title: 'نام شعبه',
                    field: 'domainData',
                    subField:"fullName"
                },
                {
                    title: 'تعداد موجودی',
                    field: 'stockCount'
                },
                 {
                    title: 'تعداد فروخته شده',
                    field: 'soldCount'
                },
                {
                    title: 'تعداد قفل شده',
                    field: 'lockCount'
                }
            ],
        }
    },
    methods: {
        getData() {
            this.$api.get(`Cards/Theme/${this.$route.params.id}`).then(({ data }) => {
                if (data.status) {
                    this.title = data.result.themeId.theme.title;
                    this.address = data.result.themeId.theme.address;
                    this.price = new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(data.result.themeId.theme.price);
                    this.inventory = data.result.themeId.theme.inventory;
                    this.stocks = data.result.themeId.theme.stocks;
                    this.status = data.result.themeId.theme.status ? 1 : 0;
                    let categories = [];
                    data.result.themeId.theme.themCategories.map(c => categories.push(c.categoryId))
                    this.categoriesId = categories;
                    this.cardType = data.result.themeId.theme.type == 0 ? 0 : 1;
                }
            });
            this.$api.get('Cards/Categories').then(({ data }) => {
                this.categories = data.result;
            });
        },
        numberFormat() {
            let value = this.price.toString().replace(/,/g, '');
            value = new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(value);
            if (value == 'NaN')
                value = '';
            this.price = value;
        },
        async toBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        changeCardType(val) {
            this.cardType = val
        },
        async setFileData(e) {
            const file = e.target.files[0];
            if (file.size > 1000000) {
                this.$swal({
                    title: 'خطا',
                    icon: 'error',
                    text: 'حجم عکس نمی تواند بیشتر از 1 مگابایت باشد'
                });
                document.getElementById('file').setAttribute('placeholder', 'انتخاب کنید');
                this.image = '';
            } else {
                const finalFile = await this.toBase64(file);
                this.image = finalFile;
                document.getElementById('file').setAttribute('placeholder', file.name);
            }
        },
        submit() {
            this.showLoading = true;
            const postedData = {
                themeId: this.$route.params.id,
                title: this.title,
                price: parseInt(this.price.toString().replace(/,/g, '')),
                inventory: this.inventory,
                status: this.status == 1 ? true : false,
                categoriesId: this.categoriesId,
                type: this.cardType,
            }
            this.$api.post('Themes/Update', postedData).then(({ data }) => {
                if (data.status)
                    this.$swal({
                        icon: 'success',
                        title: 'تبریک !',
                        text: 'طرح مورد نظر با موفقیت به روزرسانی شد',
                    })
            }).catch(({ response }) => {
                let html = '';
                response.data.errors.map(err => html += err.message + '<br>');
                this.$swal({
                    icon: 'error',
                    title: 'خطا !',
                    html
                });
            }).finally(() => {
                this.showLoading = false;
            })
        }
    },
    created() {
        this.getData();
    },
}
</script>